import MissedSalesApi from "../api/MissedSales";
import { MissedSalesInputValues, TacticalPartsInputValues } from "../types/model";

export const getMissedSales = (values: MissedSalesInputValues) => {
    return MissedSalesApi.getMissedSales(values);
}